import axios from 'axios';
import { installRequestId } from '../utils/requestId';
import { resolveMonolithApiBaseUrl } from './resolveApiBaseUrl';

const API_BASE_URL = resolveMonolithApiBaseUrl(
  ['REACT_APP_CART_API_URL', 'REACT_APP_ORDERS_API_URL', 'REACT_APP_API_BASE_URL'],
  'http://localhost:8001',
);

// Create axios instance with credentials to send cookies
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,  // Send cookies with requests (httpOnly cookies)
});
installRequestId(api);

// Request interceptor - cookies are sent automatically by browser
api.interceptors.request.use(
  (config) => {
    // Cookies are automatically sent when withCredentials: true
    // No need to manually add Authorization header
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const cartAPI = {
  // Get cart items
  getCart: async () => {
    const response = await api.get('/api/cart/items/');
    return response.data;
  },

  /** Add to cart using strict payload: { listing_type, listing_id, quantity }. */
  addToCart: async (cartItem) => {
    const payload = { ...cartItem };
    const normalizeListingType = (value) => {
      const raw = String(value || '').trim().toLowerCase();
      if (!raw) return null;
      if (raw === 'wedding essentials' || raw === 'wedding-essentials') return 'wedding_essentials';
      if (raw === 'luxury') return 'pre-owned';
      return raw;
    };
    payload.listing_type = normalizeListingType(payload.listing_type);
    if (!payload.listing_type || payload.listing_id == null) {
      throw new Error('addToCart requires listing_type and listing_id');
    }
    const response = await api.post('/api/cart/items/', payload);
    return response.data;
  },

  /** cartItemId = cart_item_id */
  updateCartItem: async (cartItemId, quantity) => {
    const response = await api.patch(`/api/cart/items/${cartItemId}/`, { quantity });
    return response.data;
  },

  removeFromCart: async (cartItemId) => {
    const response = await api.delete(`/api/cart/items/${cartItemId}/`);
    return response.data;
  },

  // Clear cart
  clearCart: async () => {
    const response = await api.delete('/api/cart/items/');
    return response.data;
  },
};
